module.exports = __webpack_public_path__ + "img/people-49-min.a2c4abca.png";